import React, { useState } from "react";
import { Button, ButtonGroup, Dropdown, DropdownButton, Modal } from "react-bootstrap";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import * as commonApi from "../../../api/commonApi";
import { Common, MESSAGES, SUCCESS } from "../../../helper";
import { RenameClass } from "./";
import { errorMsg, success } from "../../Shared";

import "../../../assets/stlyes/Modals.css";
import "bootstrap/dist/css/bootstrap.min.css";


const TeachingAction = (props) => {
  const { classId, setSwitchTab, SetPupilClassId, getData, classData } = props;
  const [editClass, setEditClass] = useState(false);
  const [isClassId, setIsClassId] = useState("");
  const MySwal = withReactContent(Swal);


  const deleteClass = () => {
    if (classData.classSize !== 0) {
      errorMsg(MESSAGES.Please_Move_ALL_Pupil_Before_Delete)
    } else {
      MySwal.fire({
        title: Common.Delete,
        text: Common.Deleteclass,
        type: "success",
        showCancelButton: true,
        confirmButtonText: Common.Deleteclass,
      }).then((result) => {
        if (result.value) {
          confirmDeleteClass();
        } else {
          errorMsg(Common.NotDeleted)
        }
      });
    }
  }

  const confirmDeleteClass = async () => {
    const deleteClass = await commonApi.deleteClass({
      id: classId,
      active: false
    });
    if (deleteClass.Items.active === false) {
      success(SUCCESS.CLASS_DELETED);
      getData();
    }
  }

  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        id="dropdown-variants-Secondary"
        title={"Action"}
      >
        <Button
          onClick={() => {
            setIsClassId(classId);
            setEditClass(true);
          }}
          className="modal-button d-flex justify-content-start"
        >
          <ModeEditOutlineOutlinedIcon />&nbsp;{Common.RenameClass}
        </Button>
        <Button
          onClick={() => {
            setSwitchTab(false);
            SetPupilClassId(classId)
          }}
          className="modal-button d-flex justify-content-start"
        >
          <VisibilityIcon />&nbsp;
          {Common.View}
        </Button>
        <Dropdown.Divider />
        <Button type="button" onClick={deleteClass} className="modal-button-danger d-flex justify-content-start" > <DeleteOutlineOutlinedIcon />&nbsp;{Common.DeleteClass} </Button>
      </DropdownButton>

      <Modal
        show={editClass}
        onHide={() => {
          setEditClass(false);
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{Common.RenameClass}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RenameClass isClassId={isClassId} setEditClass={setEditClass} getData={getData} classData={classData} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
}

export { TeachingAction };
